export interface TourStep {
  /** CSS selector for the target element, e.g. '[data-tour="league-tabs"]'. Omit for a centered intro/overlay step. */
  element?: string;
  popover: {
    title: string;
    description: string;
    side?: 'top' | 'bottom' | 'left' | 'right';
    align?: 'start' | 'center' | 'end';
  };
  /** Only show on specific platform. Default: 'all' */
  platform?: 'mobile' | 'desktop' | 'all';
}

export interface TourDefinition {
  /** Unique ID used as localStorage key, e.g. 'league-detail' */
  id: string;
  /** Semver version -- bumping this re-triggers the tour for returning users */
  version: string;
  /** Human-readable name shown in replay button tooltip */
  name: string;
  steps: TourStep[];
  /** 'first-visit' auto-shows on page load (default); 'manual-only' requires help button */
  trigger?: 'first-visit' | 'manual-only';
  /** Delay in ms before auto-starting. Default: 500. Use 800-1000 for data-heavy pages. */
  autoStartDelay?: number;
}

/** Mobile breakpoint matching use-mobile.tsx */
export const MOBILE_BREAKPOINT = 768;
